import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import './index.css';
import App from './App';
import { rewriteApiUrl } from './runtimeConfig';

const nativeFetch = window.fetch.bind(window);

window.fetch = (input: RequestInfo | URL, init?: RequestInit): Promise<Response> => {
  if (typeof input === 'string') {
    return nativeFetch(rewriteApiUrl(input), init);
  }

  if (input instanceof Request) {
    const rewrittenUrl = rewriteApiUrl(input.url);
    if (rewrittenUrl !== input.url) {
      return nativeFetch(new Request(rewrittenUrl, input), init);
    }
  }

  return nativeFetch(input as any, init);
};

axios.interceptors.request.use((config) => {
  if (config.url) {
    config.url = rewriteApiUrl(config.url);
  }
  return config;
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
